/**
 * Collection page: subcollection rail, filter drawer, grid density toggle.
 */
(function () {
  var DESKTOP_MQ = '(min-width: 990px)';
  var GRID_STORAGE_KEY = 'ge-collection-grid-cols';

  function sheet() {
    return document.getElementById('GeFacetSheet');
  }

  function collectionRoot() {
    return document.querySelector('.ge-collection');
  }

  function filterLayout() {
    var root = collectionRoot();
    return (root && root.getAttribute('data-filter-layout')) || 'drawer';
  }

  function filtersExpandedByDefault() {
    var root = collectionRoot();
    return !root || root.getAttribute('data-filters-expanded') !== 'false';
  }

  function isDesktop() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function setExpanded(open) {
    var toggle = document.getElementById('Facets-Toggle');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function labelApply() {
    var label = document.querySelector('#ProductCount .facets__label');
    var button = document.querySelector('.ge-facet-sheet__apply span');
    if (!label || !button) return;
    var match = (label.textContent || '').match(/(\d+)/);
    if (!match) return;
    button.textContent = 'Show results [' + match[1] + ']';
  }

  function enhanceSort(root) {
    var form = root.querySelector('#FacetFiltersFormMobile');
    if (!form) return;
    var select = form.querySelector('#SortByMobile');
    if (!select) return;
    var existing = form.querySelector('.ge-sort-facet');
    if (existing) {
      existing.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.checked = input.value === select.value;
      });
      return;
    }

    var details = document.createElement('details');
    details.className = 'thb-filter ge-sort-facet';
    details.open = true;

    var summary = document.createElement('summary');
    summary.className = 'thb-filter-title';
    summary.innerHTML = '<span></span>Sort By';
    details.appendChild(summary);

    var sortLabels = {
      manual: 'Featured',
      'best-selling': 'Best Selling',
      'created-descending': 'New Arrivals',
      'price-descending': 'Price: High to Low',
      'price-ascending': 'Price: Low to High'
    };
    var sortOrder = ['manual', 'created-descending', 'best-selling', 'price-descending', 'price-ascending'];
    var options = Array.prototype.filter.call(select.options, function (option) {
      return sortLabels[option.value] || option.selected;
    });
    options.sort(function (a, b) {
      var ai = sortOrder.indexOf(a.value);
      var bi = sortOrder.indexOf(b.value);
      return (ai < 0 ? 99 : ai) - (bi < 0 ? 99 : bi);
    });

    var list = document.createElement('div');
    list.className = 'thb-filter-content ge-sort-facet__list';
    options.forEach(function (option) {
      var row = document.createElement('label');
      row.className = 'ge-sort-facet__option';
      var input = document.createElement('input');
      input.type = 'radio';
      input.name = 'ge-sort-facet';
      input.value = option.value;
      input.checked = option.selected;
      input.addEventListener('change', function () {
        select.value = input.value;
        var bar = document.getElementById('SortByBar');
        if (bar) bar.value = input.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
      });
      row.appendChild(input);
      row.appendChild(document.createTextNode(sortLabels[option.value] || option.text));
      list.appendChild(row);
    });
    details.appendChild(list);

    var firstRow = form.querySelector('collapsible-row');
    if (firstRow) form.insertBefore(details, firstRow);
    else form.appendChild(details);

    var nativeSort = select.closest('.thb-filter-sort-count');
    if (nativeSort) nativeSort.hidden = true;

    if (!filtersExpandedByDefault()) {
      form.querySelectorAll('details.thb-filter:not(.ge-sort-facet)').forEach(function (row) {
        row.removeAttribute('open');
      });
    }
  }

  function openFilters() {
    var root = sheet();
    if (!root) return;
    enhanceSort(root);
    labelApply();
    root.hidden = false;
    root.inert = false;
    window.requestAnimationFrame(function () {
      root.classList.add('is-open');
    });
    document.body.classList.add('ge-facets-open');
    setExpanded(true);
  }

  function closeFilters() {
    var root = sheet();
    if (!root) return;
    root.classList.remove('is-open');
    root.inert = true;
    document.body.classList.remove('ge-facets-open');
    setExpanded(false);
    window.setTimeout(function () {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 240);
  }

  function filtersOpen() {
    var root = sheet();
    return root && root.classList.contains('is-open');
  }

  function initGridToggle() {
    var root = collectionRoot();
    if (!root || root.getAttribute('data-enable-grid-toggle') !== 'true') return;
    var grid = document.getElementById('product-grid');
    var toggle = root.querySelector('[data-ge-grid-toggle]');
    if (!grid || !toggle) return;

    function applyCols(cols) {
      grid.classList.remove('ge-collection__grid--density-3', 'ge-collection__grid--density-4');
      if (cols) grid.classList.add('ge-collection__grid--density-' + cols);
      toggle.querySelectorAll('[data-ge-grid-cols]').forEach(function (btn) {
        var active = btn.getAttribute('data-ge-grid-cols') === String(cols);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.classList.toggle('is-active', active);
      });
    }

    function syncVisibility() {
      toggle.hidden = !isDesktop();
      if (!isDesktop()) {
        grid.classList.remove('ge-collection__grid--density-3', 'ge-collection__grid--density-4');
      } else {
        var saved = localStorage.getItem(GRID_STORAGE_KEY);
        if (saved === '3' || saved === '4') applyCols(saved);
      }
    }

    var saved = localStorage.getItem(GRID_STORAGE_KEY);
    if (saved === '2') {
      localStorage.setItem(GRID_STORAGE_KEY, '3');
      saved = '3';
    }
    if ((saved === '3' || saved === '4') && isDesktop()) applyCols(saved);
    else {
      var m = grid.className.match(/ge-collection__grid--cols-(\d)/);
      var def = m ? m[1] : '4';
      toggle.querySelectorAll('[data-ge-grid-cols]').forEach(function (btn) {
        var on = btn.getAttribute('data-ge-grid-cols') === def;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    toggle.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-ge-grid-cols]');
      if (!btn || !isDesktop()) return;
      var cols = btn.getAttribute('data-ge-grid-cols');
      localStorage.setItem(GRID_STORAGE_KEY, cols);
      applyCols(cols);
    });

    window.matchMedia(DESKTOP_MQ).addEventListener('change', syncVisibility);
    syncVisibility();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var toggle = target.closest('#Facets-Toggle');
    if (toggle) {
      var desktopDrawer = isDesktop() && filterLayout() === 'drawer';
      var mobileSheet = !isDesktop();
      if (!(desktopDrawer || mobileSheet)) return;

      event.preventDefault();
      event.stopPropagation();
      if (filtersOpen()) closeFilters();
      else openFilters();
      return;
    }

    if (target.closest('[data-ge-facet-close], .click-capture')) {
      if (filtersOpen()) closeFilters();
      return;
    }

    var prev = target.closest('[data-ge-rail-prev]');
    var next = target.closest('[data-ge-rail-next]');
    if (!prev && !next) return;
    var scroller = document.querySelector('.ge-collection-rail__scroller');
    if (!scroller) return;
    event.preventDefault();
    var card = scroller.querySelector('.ge-collection-rail__card');
    var distance = card ? card.getBoundingClientRect().width + 16 : 280;
    scroller.scrollBy({ left: prev ? -distance : distance, behavior: 'smooth' });
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && filtersOpen()) closeFilters();
  });

  /* Toolbar sort: themed dropdown that drives the native select (#SortByBar), so the
     theme's facet form still handles the request. Re-applied after AJAX re-renders. */
  function enhanceBarSort() {
    var select = document.getElementById('SortByBar');
    if (!select || select.dataset.geSortEnhanced === 'true') return;
    var wrap = select.closest('.ge-facets-bar__sort-select');
    if (!wrap) return;
    select.dataset.geSortEnhanced = 'true';
    wrap.classList.add('ge-sort--enhanced');

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ge-sort__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    var current = document.createElement('span');
    current.className = 'ge-sort__current';
    button.appendChild(current);
    button.insertAdjacentHTML('beforeend', '<svg class="ge-sort__chevron" viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 4.5 6 8l3.5-3.5" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>');

    var list = document.createElement('ul');
    list.className = 'ge-sort__panel';
    list.setAttribute('role', 'listbox');
    list.id = 'GeSortPanel';
    list.hidden = true;
    button.setAttribute('aria-controls', list.id);

    Array.prototype.forEach.call(select.options, function (option) {
      var li = document.createElement('li');
      li.className = 'ge-sort__option';
      li.setAttribute('role', 'option');
      li.tabIndex = -1;
      li.dataset.value = option.value;
      li.textContent = option.text;
      list.appendChild(li);
    });

    function sync() {
      var opt = select.options[select.selectedIndex];
      current.textContent = opt ? opt.text : '';
      list.querySelectorAll('.ge-sort__option').forEach(function (li) {
        var on = li.dataset.value === select.value;
        li.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }
    function open() {
      list.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      var sel = list.querySelector('[aria-selected="true"]') || list.firstElementChild;
      if (sel) sel.focus();
    }
    function close(focusButton) {
      list.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      if (focusButton) button.focus();
    }
    function choose(value) {
      close(true);
      if (value === select.value) return;
      select.value = value;
      sync();
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }

    button.addEventListener('click', function () {
      if (list.hidden) open(); else close(false);
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.ge-sort__option');
      if (li) choose(li.dataset.value);
    });
    list.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(list.children);
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (items[i]) choose(items[i].dataset.value); }
      else if (e.key === 'Escape' || e.key === 'Tab') { close(e.key === 'Escape'); }
    });
    document.addEventListener('click', function (e) {
      if (!list.hidden && !wrap.contains(e.target)) close(false);
    });

    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    wrap.appendChild(button);
    wrap.appendChild(list);
    sync();
  }

  enhanceBarSort();
  new MutationObserver(function () { enhanceBarSort(); }).observe(document.body, { childList: true, subtree: true });

  initGridToggle();
})();
